/* eslint-disable max-lines */
import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  InputAdornment,
  InputLabel,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/system';
import PropTypes from 'prop-types';
import {
  ABC_BENEFICIARY_HEADING_ADD,
  ABC_BENEFICIARY_HEADING_VIEW,
  AGE_LIMIT_CD_IRA,
  BENEFICIARY_INFO,
  CONTRIBUTION_LIMIT_CD_IRA,
  CONTRIBUTION_YEAR,
  DEPOSIT_AMOUNT,
  DONE,
  EDUCATIVA_BENEFICIARY_HEADING_ADD,
  EDUCATIVA_BENEFICIARY_HEADING_VIEW,
  FAILED,
  INVALID_FORMAT_ERR,
  LETS_START_SUB_HEAD,
  MANDATORY_FIELD_ERR,
  REQUIRED,
  SUBMIT_TAX_EXTENSION_DOCUMENT,
  TOOLTIP_ABC_BIRTH_PROOF,
  TOOLTIP_EDUCATIVA_BIRTH_PROOF,
  TOOLTIP_TAX_EXTENSION_DOCUMENT,
} from '../../../constants';
import { productMapping } from '../../../services/productMapping';
import { CommonStyles } from '../CommonStyles';
import { ContactInformationStyles as classes } from '../StepOne/ContactInformationStyles';
import CustomTextCard from './CustomTextCard';
import { commonUtility } from '../UtilityFunctions';
import {
  commonTernary,
  isABCProduct,
  isBundle,
  isCDIraproduct,
  isIRAEducativaProduct,
  isWebComponentFlow,
  nbrToCurrencyFormat,
  yearCalculatorPR,
} from '../../commonCode';
import { CustomInput } from '../CustomInput/CustomInput';
import { InfoFilledIcon, TriangleAlert } from '../../../images/svg/CustomizedSVG';
import CustomInfoBanner from '../CustomInfoBanner/CustomInfoBanner';
import { CustomLinearProgres } from './CustomLinearProgress';
import { productNameURLMapping } from '../../../services/productNameURLMapping';
import CDIRAModals from './CDIRAModals';
import { clearContext } from '../../clearContext';
import { saveKnockOffData } from '../../DGI/CommonFunctions';
import CommonDocumentUpload from '../../Sidebar/CommonDocumentUpload';
import BeneficiaryInfo from './BeneficiaryInfo';
import { BeneficiaryCompStyles as styles } from './BeneficiaryCompStyles';
import beneficiaryEtbIcon from '../../../images/beneficiaryEtbIcon.svg';
import { CustomSelect } from '../CustomSelect/CustomSelect';
import { getContributionYear } from '../../../services/formService';
import Loader from '../../Loader/Loader';
import { openLinkOrDownloadWithoutIsSafeUrl } from '../../../WebComponents/commonComponents/customUtils';
import BeneficiaryCardComp from './BeneficiaryCardComp';

const BeneficiaryContent = (props) => {
  const { t } = useTranslation();
  const { history } = props;
  const baseContext = isWebComponentFlow();
  const {
    productName,
    setProductDataIRA,
    productDataIRA,
    setProductDataIRAErrors,
    productDataIRAErrors,
    theme,
    flowTypeETB,
    setIsBeneficiaryScreenDirty,
    setIsScreenFiveDirty,
    setIsFundingScreenDirty,
    cdFlowOffers,
    contributionYear,
    language,
    location,
    setProductName,
    setProductType,
    setContributionYear,
    setFlowTypeETB,
    setFundData,
    setFundDataErrors,
    fundData,
    accessToken,
    setTaxProofUploadStatus,
    taxProofUploadStatus,
    taxFileData,
    setTaxFileData,
    setTaxLinearProgress,
    setTaxUploadProgress,
    cardsList,
    setCardsList,
    setApplicationId,
    setOrientalAccountCardValue,
    beneficiaryData,
    setBeneficiaryData,
    beneficiaryDataErrors,
    setBeneficiaryDataErrors,
    setBirthProofUploadStatus,
    setBirthProofUploadData,
    setBirthProofUploadError,
    setAuthorityProofUploadStatus,
    setAuthorityProofUploadData,
    setAuthorityProofUploadError,
    setSingleAccDis,
    setPlaidAccNoLinked,
    plaidAccNoLinked,
    plaidDetails,
    etbLogin,
    otpToken,
    customerAppId,
    initiateUiResponse,
    birthProofUploadStatus,
    birthProofUploadData,
    birthProofUploadError,
  } = baseContext;
  const commonClasses = CommonStyles(theme);
  const { remainingContribution, maxContribution } = productDataIRA;
  const [bannerData, setBannerData] = useState({});
  const [loader, setLoader] = useState(false);
  const [openCDIraModal, setOpenCDIraModal] = useState(false);
  const [cdIraModalContent, setCdIraModalContent] = useState('');
  const EligibleForCurrentYear = contributionYear?.EligibleForCurrentYear === 'true';
  const EligibleForPreviousYear = contributionYear?.EligibleForPreviousYear === 'true';
  const isIRAEducativa = isIRAEducativaProduct(productName);
  const isABC = isABCProduct(productName);
  const amountCalcuationForYear =
    productDataIRA?.yearStatus?.id === 'currentTaxYear'
      ? contributionYear.CurrentYearBalance
      : contributionYear?.PreviousYearBalance;
  const date = yearCalculatorPR();
  const { year, currentDateInPR, october15Deadline, isBtwAprilAndOct15 } = date;
  const themes = useTheme();
  const isTab = useMediaQuery(themes?.breakpoints?.down(900), {
    defaultMatches: true,
  });

  let beneficiaryList = [];
  if (productDataIRA?.yearStatus?.id === 'priorTaxYear') {
    beneficiaryList =
      beneficiaryData?.list?.PreviousYearBeneficiaries?.map((item) => ({
        beneficiaryName: item?.BeneficiaryFullName,
        beneficiaryCustId: item?.BeneficiaryCustId,
        beneficiaryAmount: item?.Balance,
        beneficiaryTaxID: item?.BeneficiaryTaxId,
        beneficiaryDOB: item?.BeneficiaryDOB,
        relationType: item?.RelationType,
        specificRelation: item?.SpecificRelation,
        dobUploadFlag: item?.DobUploadFlag,
      })) || [];
  } else if (productDataIRA?.yearStatus?.id === 'currentTaxYear') {
    beneficiaryList =
      beneficiaryData?.list?.CurrentYearBeneficiaries?.map((item) => ({
        beneficiaryName: item?.BeneficiaryFullName,
        beneficiaryCustId: item?.BeneficiaryCustId,
        beneficiaryAmount: item?.Balance,
        beneficiaryTaxID: item?.BeneficiaryTaxId,
        beneficiaryDOB: item?.BeneficiaryDOB,
        relationType: item?.RelationType,
        specificRelation: item?.SpecificRelation,
        dobUploadFlag: item?.DobUploadFlag,
      })) || [];
  } else if (isABC) {
    beneficiaryList =
      beneficiaryData?.list?.map((item) => ({
        beneficiaryName: item?.BeneficiaryName,
        beneficiaryCustId: item?.BeneficiaryCustId,
        beneficiaryTaxID: item?.BeneficiaryTaxId,
        beneficiaryAge: item?.BeneficiaryAge,
        beneficiaryDOB: item?.BeneficiaryDOB,
        accountType: item?.accountType,
        Gender: item?.Gender,
        accountNumber: item?.accountNumber,
        accountBalance: item?.accountBalance,
        dobUploadFlag: item?.DobUploadFlag,
      })) || [];
  }
  useEffect(() => {
    getMaximumDepositAmount();
  }, [accessToken]);

  const getMaximumDepositAmount = async () => {
    if (
      accessToken &&
      flowTypeETB === 'EtbFlow' &&
      (isCDIraproduct(productName)
        ? Object.keys(contributionYear).length === 0
        : !beneficiaryData?.list)
    ) {
      setLoader(true);
      let response = null;

      response = await getContributionYear(
        etbLogin,
        otpToken,
        productMapping(productName),
        customerAppId,
        initiateUiResponse,
        { isWCFlow: baseContext?.wcFlow, env: baseContext?.environment }
      );
      if (response?.status === 200) {
        setLoader(false);
        if (isCDIraproduct(productName)) {
          setContributionYear(response?.data);
        } else {
          setBeneficiaryData((prev) => ({
            ...prev,
            list: isABC ? response?.data?.beneficiaries : response?.data,
            ...(isABC && {
              etbSelection: response?.data?.beneficiaries?.length > 0 ? 'view' : 'add',
            }),
          }));
        }
      }
    }
  };
  const getBannerText = (limit) =>
    isIRAEducativa
      ? t('Product screen Educativa banner text', {
          contributionAmount: `${Number(findAmount()).toLocaleString()}`,
          balanceAmount: `${(1000 - Number(findAmount())).toLocaleString()}`,
        })
      : t('Product screen IRA banner text', {
          contributionAmount: `${Number(amountCalcuationForYear).toLocaleString()}`,
          balanceAmount: `${(limit - Number(amountCalcuationForYear)).toLocaleString()}`,
        });

  const handleBannerLinkClick = () => {
    setIsBeneficiaryScreenDirty(true);
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    setProductDataIRA((prev) => ({
      ...prev,
      depositAmount: `${maxContribution}`,
    }));
    if (maxContribution >= 250 && !isIRAEducativa) {
      setProductDataIRAErrors((prev) => ({
        ...prev,
        depositAmount: '',
      }));
    }
    if (maxContribution >= 100 && isIRAEducativa) {
      setProductDataIRAErrors((prev) => ({
        ...prev,
        depositAmount: '',
      }));
    }
  };

  useEffect(() => {
    const limit = contributionLimits[productDataIRA?.yearStatus?.id] || 5000;
    if (remainingContribution <= 0) {
      setBannerData((prevState) => ({
        ...prevState,
        handleLinkClick: handleBannerLinkClick,
        linkData: 'Set to maximum allowed',
        linkDisabledCondition: commonTernary(
          isIRAEducativa,
          findAmount() <= 99,
          Number(amountCalcuationForYear) <= 249
        ),
        Icon: <TriangleAlert color="#D5151F" />,
        backgroundColor: '#FBE8E9',
        borderColor: '#FF6971',
        iconColor: '#D5151F',
        bannerText1: getBannerText(limit),
      }));
    } else {
      setBannerData((prevState) => ({
        ...prevState,
        linkData: '',
        Icon: <InfoFilledIcon color="#0F5FD7" />,
        backgroundColor: '#E3EDFC',
        borderColor: '#3285FF',
        iconColor: '#0F5FD7',
        bannerText1: getBannerText(limit),
      }));
    }
  }, [remainingContribution, productDataIRA?.yearStatus, t]);

  const handleYearChange = async (e, status) => {
    e.preventDefault();
    if (productDataIRA?.yearStatus !== status) {
      setIsBeneficiaryScreenDirty(true);
      setIsScreenFiveDirty(true);
      setIsFundingScreenDirty(true);
      const currentDeposit = productDataIRA?.depositAmount;
      const errorMsg = validateDepositAmount(currentDeposit, status?.id);
      const errorMsgMax = validateDepositAmountMax(currentDeposit, status?.id);
      setProductDataIRA((prevState) => ({
        ...prevState,
        yearStatus: status,
        document: '',
      }));
      setTaxProofUploadStatus(null);
      setTaxFileData({});
      setTaxLinearProgress(false);
      setTaxUploadProgress(0);
      setProductDataIRAErrors((prevState) => ({
        ...prevState,
        yearStatus: '',
        document: '',
        depositAmount: errorMsg || errorMsgMax,
      }));
      setBeneficiaryData((prev) => ({
        ...prev,
        firstName: '',
        lastName: '',
        middleName: '',
        secondLastName: '',
        ssn: '',
        dob: '',
        gender: '',
        relationship: '',
        otherRelation: '',
        beneficiaryListCustId: '',
        beneficiaryLists: {},
        beneficiaryListName: '',
      }));
      setBeneficiaryDataErrors({});
      setBirthProofUploadStatus(null);
      setBirthProofUploadData({});
      setBirthProofUploadError({});
      setAuthorityProofUploadStatus(null);
      setAuthorityProofUploadData({});
      setAuthorityProofUploadError({});
      if (cdFlowOffers?.iraType !== 'CD IRA Roth' && flowTypeETB === 'EtbFlow' && !isIRAEducativa) {
        if (!EligibleForCurrentYear && EligibleForPreviousYear && status?.id === 'currentTaxYear') {
          setOpenCDIraModal(true);
          setCdIraModalContent({
            heading: 'You are only eligible to open a CD IRA for the previous tax year',
            text1:
              'Due to your age (75 or older), it is not possible to open a CD IRA for the current tax year.',
            text2: 'Click Continue to proceed with opening your CD IRA for the previous tax year.',
            button2: 'Continue',
            button2OnClick: () => {
              setCardsList([
                {
                  text: `${year} tax year`,
                  id: 'currentTaxYear',
                  disabled: true,
                },
                {
                  text: `${year - 1} tax year`,
                  id: 'priorTaxYear',
                },
              ]);
              // setProductDataIRA((prevState) => ({
              //   ...prevState,
              //   yearStatus: {
              //     text: `${year - 1} tax year`,
              //     id: 'priorTaxYear',
              //   },
              // }));
              setOpenCDIraModal(false);
            },
            onClose: () => {
              setOpenCDIraModal(false);
              setProductDataIRA((prevState) => ({
                ...prevState,
                knockOFf: true,
              }));
              setCardsList([
                {
                  text: `${year} tax year`,
                  id: 'currentTaxYear',
                  disabled: true,
                },
                {
                  text: `${year - 1} tax year`,
                  id: 'priorTaxYear',
                },
              ]);
              // setProductDataIRA((prevState) => ({
              //   ...prevState,
              //   yearStatus: {
              //     text: `${year - 1} tax year`,
              //     id: 'priorTaxYear',
              //   },
              // }));
            },
          });
          setProductDataIRA((prevState) => ({
            ...prevState,
            knockOFf: true,
          }));
          await saveKnockOffData(baseContext, AGE_LIMIT_CD_IRA);
        } else if (!EligibleForCurrentYear && !EligibleForPreviousYear) {
          setOpenCDIraModal(true);
          setCdIraModalContent({
            heading: 'You are not eligible to open a CD IRA',
            text1: 'Due to your age (75 or older), it is not possible to open a CD IRA account.',
            text2: 'Discover how our Certificates of Deposit can help your money grow.',
            alertIcon: true,

            button1: 'Learn more about CDs',
            button1OnClick: () => {
              // window.open(
              //   'https://orientalbank.com/en/for-you/banking-accounts/certificates-of-deposit',
              //   '_blank'
              // );
              openLinkOrDownloadWithoutIsSafeUrl(
                language === 'ES'
                  ? 'https://orientalbank.com/es/para-ti/cuentas-bancarias/certificados-de-deposito/'
                  : 'https://orientalbank.com/en/for-you/banking-accounts/certificates-of-deposit/'
              );
            },
            button2: 'Open a CD',
            button2OnClick: () => {
              clearContext(baseContext);
              setApplicationId(null);
              baseContext.setCdFlowOffers({
                depositAmount: '',
                minDepositAmount: 1000,
                offers: {},
                iraType: '',
              });
              baseContext.setAccessToken(accessToken);
              baseContext.setLanguage(language);
              setProductName('Certificate of Deposit');
              setProductType('Certificate of Deposit');
              setFlowTypeETB(flowTypeETB);
              if (baseContext?.wcFlow) {
                history.push('offers');
              } else {
                history.push({
                  pathname: `/${location?.toLowerCase()}/${language.toLowerCase()}/express/retail-form/${productNameURLMapping(
                    'Certificate of Deposit'
                  )}/certificate-of-deposit`,
                });
              }
            },
          });
          await saveKnockOffData(baseContext, AGE_LIMIT_CD_IRA);
          setProductDataIRA((prevState) => ({
            ...prevState,
            knockOFf: true,
          }));
        } else {
          setProductDataIRA((prevState) => ({
            ...prevState,
            knockOFf: false,
          }));
        }
      } else {
        setProductDataIRA((prevState) => ({
          ...prevState,
          knockOFf: false,
        }));
      }

      if (
        (status?.id === 'currentTaxYear' &&
          (beneficiaryData?.list?.CurrentYearBeneficiaries?.length ?? 0) > 0) ||
        (status?.id === 'priorTaxYear' &&
          (beneficiaryData?.list?.PreviousYearBeneficiaries?.length ?? 0) > 0)
      ) {
        setBeneficiaryData((prev) => ({
          ...prev,
          captureInfo: true,
        }));
      } else {
        setBeneficiaryData((prev) => ({
          ...prev,
          captureInfo: false,
        }));
      }

      if (isIRAEducativa && flowTypeETB === 'EtbFlow') {
        setBeneficiaryData((prev) => {
          if (
            (status?.id === 'currentTaxYear' &&
              (prev?.list?.EligibleForCurrentYear === 'false' ||
                (prev?.list?.CurrentYearBeneficiaries?.length ?? 0) <= 0)) ||
            (status?.id === 'priorTaxYear' &&
              (prev?.list?.EligibleForPreviousYear === 'false' ||
                (prev?.list?.PreviousYearBeneficiaries?.length ?? 0) <= 0))
          ) {
            return { ...prev, etbSelection: 'add' };
          }
          return { ...prev, etbSelection: 'view' };
        });
      }
    }
  };
  const getCardsList = () => {
    if (currentDateInPR <= october15Deadline) {
      return isIRAEducativa
        ? [
            { text: `${year - 1} tax year`, id: 'priorTaxYear' },
            { text: `${year} tax year`, id: 'currentTaxYear' },
          ]
        : [
            { text: `${year} tax year`, id: 'currentTaxYear' },
            { text: `${year - 1} tax year`, id: 'priorTaxYear' },
          ];
    }

    return [{ text: `${year} tax year`, id: 'currentTaxYear' }];
  };
  const contributionLimits = {
    priorTaxYear: 7000,
    currentTaxYear: 7500,
  };

  useEffect(() => {
    if (productDataIRA?.yearStatus?.id === 'currentTaxYear') {
      setProductDataIRA((prevState) => ({
        ...prevState,
        remainingContribution:
          Number(isIRAEducativa ? findAmount() : contributionYear?.CurrentYearBalance) -
          Number((productDataIRA?.depositAmount ?? '0').toString().replace(/,/g, '')),
        maxContribution: Number(
          isIRAEducativa ? findAmount() : contributionYear?.CurrentYearBalance
        ),
      }));
    } else if (productDataIRA?.yearStatus?.id === 'priorTaxYear') {
      setProductDataIRA((prevState) => ({
        ...prevState,
        remainingContribution:
          Number(isIRAEducativa ? findAmount() : contributionYear?.PreviousYearBalance) -
          Number((productDataIRA?.depositAmount ?? '0').toString().replace(/,/g, '')),
        maxContribution: Number(
          isIRAEducativa ? findAmount() : contributionYear?.PreviousYearBalance
        ),
      }));
    }
  }, [
    productDataIRA.yearStatus,
    productDataIRA.depositAmount,
    beneficiaryData?.beneficiaryListCustId,
  ]);

  useEffect(() => {
    const cardList = cardsList?.length > 0 ? cardsList : getCardsList();
    setCardsList(cardList);
    if (Object.entries(contributionYear).length > 0) {
      const values = Object.values(contributionYear).map(Number);
      const selectedLimit = contributionLimits[productDataIRA?.yearStatus?.id] || 0;
      const isIraContributionMorethanLimit = values.every((val) => val > selectedLimit);
      const maxedOutCondition =
        Number(contributionYear.CurrentYearBalance) > contributionLimits.currentTaxYear &&
        Number(contributionYear.PreviousYearBalance) < contributionLimits.priorTaxYear &&
        currentDateInPR >= october15Deadline;

      const isCurrentYearOnly =
        cardList?.find((x) => x?.id === 'currentTaxYear') && cardList?.length === 1;
      const isPreviousYearOnly =
        cardList?.find((x) => x?.id === 'priorTaxYear') && cardList?.length === 1;

      const bothYears = cardList?.find((x) => x?.id === 'priorTaxYear') && cardList?.length === 2;

      if (flowTypeETB === 'EtbFlow' && !isIRAEducativa) {
        if (
          isIraContributionMorethanLimit ||
          maxedOutCondition ||
          (isPreviousYearOnly && Number(contributionYear?.CurrentYearBalance) < 250) ||
          (isCurrentYearOnly && Number(contributionYear?.CurrentYearBalance) < 250) ||
          (bothYears &&
            Number(contributionYear?.CurrentYearBalance) < 250 &&
            Number(contributionYear.PreviousYearBalance) < 250)
        ) {
          setOpenCDIraModal(true);
          setCdIraModalContent({
            heading: `You've reached your IRA contribution limit`,
            text1: 'Keep growing your investments by opening a Certificate of Deposit with us!',
            // text2: 'opening a Certificate of Deposit with us!',
            button1: 'Learn more about CDs',
            button1OnClick: () => {
              openLinkOrDownloadWithoutIsSafeUrl(
                'https://orientalbank.com/en/for-you/banking-accounts/certificates-of-deposit'
              );
              // window.open(
              //   'https://orientalbank.com/en/for-you/banking-accounts/certificates-of-deposit',
              //   '_blank'
              // );
            },
            button2: 'Open a CD',
            button2OnClick: () => {
              clearContext(baseContext);
              setApplicationId(null);
              baseContext.setCdFlowOffers({
                depositAmount: '',
                minDepositAmount: 1000,
                offers: {},
                iraType: '',
              });
              setProductName(
                language === 'EN' ? 'Certificate of Deposit' : 'Certificado de Depósito'
              ); // Certificado de Deposito // Certificado de Depósito
              setProductType('Certificate of Deposit');
              setFlowTypeETB(flowTypeETB);
              if (baseContext?.wcFlow) {
                history.push('offers');
              } else {
                history.push({
                  pathname: `/${location?.toLowerCase()}/${language.toLowerCase()}/express/retail-form/${productNameURLMapping(
                    'Certificate of Deposit'
                  )}/certificate-of-deposit`,
                });
              }
            },
          });
          setProductDataIRA((prevState) => ({
            ...prevState,
            knockOFf: true,
          }));

          saveKnockOffData(baseContext, CONTRIBUTION_LIMIT_CD_IRA);
        } else {
          setProductDataIRA((prevState) => ({
            ...prevState,
            knockOFf: false,
          }));
        }
      }
    }
  }, [contributionYear]);

  const validateDepositAmount = (amount, yearId) => {
    if (!amount) return '';

    const numericDeposit = Number(String(amount).replace(/,/g, '').trim());

    if (!isIRAEducativa && flowTypeETB !== 'EtbFlow') {
      if (numericDeposit < 250) {
        return 'A minimum deposit of $250 is required to open this account.';
      }

      const limit = Number(contributionLimits[String(yearId)] || 0);

      if (limit && numericDeposit > limit) {
        return '';
      }
    }
    if (!isIRAEducativa && flowTypeETB === 'EtbFlow') {
      if (numericDeposit < 250) {
        return 'A minimum deposit of $250 is required to open this account.';
      }
    }

    return '';
  };
  const validateDepositAmountMax = (amount, yearId) => {
    if (!amount) return false;

    const numericDeposit = Number(String(amount).replace(/,/g, '').trim());
    const limit = Number(contributionLimits[String(yearId)] || 0);
    return limit > 0 && numericDeposit > limit;
  };

  const isLimitExceeded = validateDepositAmountMax(
    productDataIRA?.depositAmount,
    productDataIRA?.yearStatus?.id
  );

  const handleChange = (e) => {
    setIsBeneficiaryScreenDirty(true);
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    if (e.target.value?.match(/^\d*$/)) {
      setProductDataIRA((prevState) => ({
        ...prevState,
        depositAmount: e.target.value,
      }));

      const numericDeposit = Number(e.target.value.replace(',', '') || 0);
      const selectedAccount = fundData?.Id
        ? plaidAccNoLinked?.find((acc) => acc.Id === fundData.Id)
        : plaidAccNoLinked?.[0];

      const isDepositValid =
        selectedAccount &&
        plaidDetails?.status === 'Success' &&
        numericDeposit <= Number(selectedAccount.Balance);

      setFundData((prevState) => ({
        ...prevState,
        depositAmount: e.target.value,
        accountNumber: isDepositValid ? selectedAccount?.AccountNumber : prevState.accountNumber,
        Id: isDepositValid ? selectedAccount?.Id : prevState.Id,
        maskedAccId: isDepositValid ? selectedAccount?.Id : prevState.maskedAccId,
        transitNumber: isDepositValid ? selectedAccount?.RoutingNumber : prevState.transitNumber,
        typeOfAccount: isDepositValid ? selectedAccount?.AccountType : prevState.typeOfAccount,
        balance: isDepositValid ? selectedAccount?.Balance : prevState.balance,
      }));
      setFundDataErrors((prevState) => ({
        ...prevState,
        depositAmount: '',
        accountNumber: '',
        transitNumber: '',
        typeOfAccount: '',
        bank: '',
        statementDocumentId: '',
      }));

      setSingleAccDis(!isDepositValid);
      setPlaidAccNoLinked((prev) =>
        prev?.map((item) => ({
          ...item,
          isDepositeGreaterThanBalancePlaid: numericDeposit > Number(item.Balance),
          isDepositeGreaterThanBalanceAnother: numericDeposit > Number(item.Balance),
          isValids: false,
          isDepositeGreaterDisableAll: false,
        }))
      );
      setOrientalAccountCardValue('');
      if (e.target.value < 250 && !isIRAEducativa) {
        setProductDataIRAErrors((prevState) => ({
          ...prevState,
          depositAmount: 'A minimum deposit of $250 is required to open this account.',
        }));
        return;
      }
      if (e.target.value < 100 && isIRAEducativa) {
        setProductDataIRAErrors((prevState) => ({
          ...prevState,
          depositAmount: 'A minimum deposit of $100 is required to open this account.',
        }));
        return;
      }
      const errorMsg = validateDepositAmount(e.target.value, productDataIRA?.yearStatus?.id);
      const errorMsgMax = validateDepositAmountMax(e.target.value, productDataIRA?.yearStatus?.id);

      setProductDataIRAErrors((prevState) => ({
        ...prevState,
        depositAmount: errorMsg || errorMsgMax,
      }));
    } else {
      setProductDataIRA((prevState) => ({
        ...prevState,
        depositAmount: e.target.value,
      }));
      setProductDataIRAErrors((prevState) => ({
        ...prevState,
        depositAmount: INVALID_FORMAT_ERR,
      }));
    }
  };
  const handleBlur = (e) => {
    if (e) {
      const { value } = e.target;
      setTimeout(() => {
        const currencyValue = value?.replace(/^0+/, '');
        const newCurrencyValue = nbrToCurrencyFormat(currencyValue);
        setProductDataIRA((prevState) => ({
          ...prevState,
          depositAmount: newCurrencyValue,
        }));
      }, 500);
    }
  };
  const handleFocus = (e) => {
    const currencyValue = e.target.value.toString().replace(/[^0-9.]/g, '');
    setProductDataIRA((prevState) => ({
      ...prevState,
      depositAmount: currencyValue,
    }));
  };

  const handleMaxButton = () => {
    setIsBeneficiaryScreenDirty(true);
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    setTimeout(() => {
      setProductDataIRA((prevState) => ({
        ...prevState,
        depositAmount: `${maxContribution}`,
      }));
      setOrientalAccountCardValue('');
      setFundDataErrors((prevState) => ({
        ...prevState,
        depositAmount: '',
      }));
      if (maxContribution >= 250 && !isIRAEducativa) {
        setProductDataIRAErrors((prevState) => ({
          ...prevState,
          depositAmount: '',
        }));
      }
      if (maxContribution >= 100 && isIRAEducativa) {
        setProductDataIRAErrors((prevState) => ({
          ...prevState,
          depositAmount: '',
        }));
      }
    }, 700);
  };

  const findAmount = () => {
    let amount = 0;
    if (productDataIRA?.yearStatus?.id === 'priorTaxYear') {
      const selectedOption = beneficiaryData?.list?.PreviousYearBeneficiaries?.find(
        (item) => item.BeneficiaryCustId === beneficiaryData?.beneficiaryListCustId
      );
      amount = selectedOption?.Balance;
    } else if (productDataIRA?.yearStatus?.id === 'currentTaxYear') {
      const selectedOption = beneficiaryData?.list?.CurrentYearBeneficiaries?.find(
        (item) => item.BeneficiaryCustId === beneficiaryData?.beneficiaryListCustId
      );
      amount = selectedOption?.Balance;
    }
    return amount;
  };

  const handleBeneficiarySelection = (e) => {
    setIsBeneficiaryScreenDirty(true);
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    const { value } = e.target;
    if (value.length > 0 && beneficiaryData?.beneficiaryListCustId !== value) {
      setBeneficiaryData((prevState) => ({
        ...prevState,
        relationship: '',
        otherRelation: '',
        addressInfo: { ...prevState?.addressInfo, ...(isABC && { sameBeneficiaryAddress: true }) },
      }));
      setBeneficiaryDataErrors((prevState) => ({
        ...prevState,
        relationship: '',
        otherRelation: '',
        addressInfo: {
          beneficiaryAddress1: '',
          beneficiaryAddress2: '',
          beneficiaryCity: '',
          beneficiaryCountry: '',
          beneficiaryState: '',
          beneficiaryZipCode: '',
          beneficiaryMailingAddress1: '',
          beneficiaryMailingAddress2: '',
          beneficiaryMailingCity: '',
          beneficiaryMailingCountry: '',
          beneficiaryMailingState: '',
          beneficiaryMailingZipCode: '',
        },
      }));
      setBirthProofUploadData({});
      setBirthProofUploadError({});
      setBirthProofUploadStatus(null);
      setAuthorityProofUploadData({});
      setAuthorityProofUploadError({});
      setAuthorityProofUploadStatus(null);
      setTaxUploadProgress((prev) => ({
        ...prev,
        'Proof of guardianship': 0,
        'Proof of custodianship': 0,
        'Date of birth certificate': 0,
      }));
      setTaxLinearProgress((prev) => ({
        ...prev,
        'Proof of guardianship': false,
        'Proof of custodianship': false,
        'Date of birth certificate': false,
      }));
    }
    if (value.length > 0) {
      const selectedOption = beneficiaryList.find((item) => item.beneficiaryCustId === value);
      setBeneficiaryData((prevState) => ({
        ...prevState,
        beneficiaryLists: beneficiaryList?.find((item) =>
          item?.beneficiaryCustId === value ? item : null
        ),
        beneficiaryListCustId: value,
        beneficiaryListName: selectedOption?.beneficiaryName,
        ...(isIRAEducativa && { relationType: selectedOption?.relationType }),
        ...(isIRAEducativa && { specificRelation: selectedOption?.specificRelation }),
      }));
      setBeneficiaryDataErrors((prevState) => ({
        ...prevState,
        beneficiaryListCustId: '',
      }));
    } else {
      setBeneficiaryData((prevState) => ({
        ...prevState,
        beneficiaryListCustId: value,
      }));
      setBeneficiaryDataErrors((prevState) => ({
        ...prevState,
        beneficiaryListCustId: MANDATORY_FIELD_ERR,
      }));
    }
  };
  const handleToggleChange = (event, newValue) => {
    setIsBeneficiaryScreenDirty(true);
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    if (newValue !== null && beneficiaryData?.etbSelection !== newValue) {
      setBeneficiaryData((prev) => ({
        ...prev,
        etbSelection: newValue,
        firstName: '',
        lastName: '',
        middleName: '',
        secondLastName: '',
        ssn: '',
        dob: '',
        gender: '',
        relationship: '',
        otherRelation: '',
        beneficiaryListCustId: '',
        beneficiaryLists: {},
        beneficiaryListName: '',
        isStudent: true,
        educationalInstitution: '',
      }));
      setBeneficiaryDataErrors((prev) => ({
        ...prev,
        etbSelection: '',
        firstName: '',
        lastName: '',
        middleName: '',
        secondLastName: '',
        ssn: '',
        dob: '',
        gender: '',
        relationship: '',
        otherRelation: '',
        beneficiaryListCustId: '',
        educationalInstitution: '',
      }));
      setBirthProofUploadStatus(null);
      setBirthProofUploadData({});
      setBirthProofUploadError({});
      setAuthorityProofUploadStatus(null);
      setAuthorityProofUploadData({});
      setAuthorityProofUploadError({});
      setTaxLinearProgress((prev) => ({
        ...prev,
        'Date of birth certificate': false,
        'Proof of custodianship': false,
        'Proof of guardianship': false,
      }));
      setTaxUploadProgress((prev) => ({
        ...prev,
        'Date of birth certificate': 0,
        'Proof of custodianship': 0,
        'Proof of guardianship': 0,
      }));
    }
  };

  const etbBeneficiaryJSX = () => (
    <Grid size={{ xs: 12 }}>
      {beneficiaryList?.length > 0 && (
        <Grid
          sx={{
            ...styles.etbContainer,
            ...(isABC && { paddingTop: '0px', marginTop: '0px', borderTop: 'none' }),
          }}
        >
          <Typography sx={styles.beneficiaryText1}>
            {t('Select your beneficiary', {
              defaultValue: 'Select your beneficiary',
            })}
          </Typography>
          <Grid
            sx={{
              ...styles.toggleContainer,
              marginTop: '0px',
              alignItems: 'start',
            }}
          >
            <Box
              component="img"
              src={beneficiaryEtbIcon}
              alt="Beneficiary Icon"
              width="48px"
              height="48px"
            />
            <Box sx={styles.etbSubHeadingGrid}>
              <Typography sx={{ ...styles.beneficiaryText2, textAlign: 'start' }}>
                {t('Select an existing or add a new beneficiary', {
                  defaultValue: 'Select an existing or add a new beneficiary',
                })}
              </Typography>
              <Typography sx={{ ...styles.beneficiaryText3, textAlign: 'start' }}>
                {isIRAEducativa
                  ? beneficiaryData?.etbSelection === 'add'
                    ? t(EDUCATIVA_BENEFICIARY_HEADING_ADD, {
                        defaultValue: EDUCATIVA_BENEFICIARY_HEADING_ADD,
                      })
                    : t(EDUCATIVA_BENEFICIARY_HEADING_VIEW, {
                        defaultValue: EDUCATIVA_BENEFICIARY_HEADING_VIEW,
                      })
                  : beneficiaryData?.etbSelection === 'add'
                  ? t(ABC_BENEFICIARY_HEADING_ADD, {
                      defaultValue: ABC_BENEFICIARY_HEADING_ADD,
                    })
                  : t(ABC_BENEFICIARY_HEADING_VIEW, {
                      defaultValue: ABC_BENEFICIARY_HEADING_VIEW,
                    })}
              </Typography>
            </Box>
          </Grid>
          <ToggleButtonGroup
            exclusive
            sx={styles.buttonGroup}
            value={beneficiaryData?.etbSelection}
            onChange={handleToggleChange}
            aria-label={t('Select an existing or add a new beneficiary', {
              defaultValue: 'Select an existing or add a new beneficiary',
            })}
          >
            {!(
              (productDataIRA?.yearStatus?.id === 'currentTaxYear' &&
                (beneficiaryData?.list?.EligibleForCurrentYear === 'false' ||
                  (beneficiaryData?.list?.CurrentYearBeneficiaries?.length ?? 0) <= 0)) ||
              (productDataIRA?.yearStatus?.id === 'priorTaxYear' &&
                (beneficiaryData?.list?.EligibleForPreviousYear === 'false' ||
                  (beneficiaryData?.list?.PreviousYearBeneficiaries?.length ?? 0) <= 0))
            ) && (
              <ToggleButton
                disableRipple
                disableFocusRipple
                value="view"
                sx={
                  beneficiaryData?.etbSelection === 'view'
                    ? styles.activeButton
                    : styles.passiveButton
                }
              >
                {t('View my beneficiaries', {
                  defaultValue: 'View my beneficiaries',
                })}
              </ToggleButton>
            )}

            <ToggleButton
              disableRipple
              disableFocusRipple
              value="add"
              sx={
                beneficiaryData?.etbSelection === 'add' ? styles.activeButton : styles.passiveButton
              }
            >
              {t('Add new beneficiary', {
                defaultValue: 'Add new beneficiary',
              })}
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
      )}
      {(beneficiaryData?.etbSelection === 'add' || beneficiaryList?.length <= 0) && !isABC && (
        <BeneficiaryInfo />
      )}
      {beneficiaryData?.etbSelection === 'view' && beneficiaryList?.length > 0 && (
        <Grid size={{ xs: 12 }} sx={{ marginTop: '20px' }}>
          <CustomSelect
            id="beneficiaryList"
            dataTestId="beneficiaryList_id"
            required
            inputLabelAriaLabel={`${t('Beneficiaries', {
              defaultValue: 'Beneficiaries',
            })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
            label={t('Beneficiaries', {
              defaultValue: 'Beneficiaries',
            })}
            options={beneficiaryList}
            handleChange={handleBeneficiarySelection}
            fullWidth
            value={beneficiaryData?.beneficiaryListCustId}
            error={beneficiaryDataErrors?.beneficiaryListCustId}
            selectAriaLabel={`${t('Beneficiaries', {
              defaultValue: 'Beneficiaries',
            })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
            placeholder="Select your beneficiary"
            isBeneficiaryList
          />
          <Box
            component="span"
            role="alert"
            sx={styles.errorMessage}
            data-testid="beneficiaryListError"
          >
            {t(beneficiaryDataErrors?.beneficiaryListCustId, {
              defaultValue: beneficiaryDataErrors?.beneficiaryListCustId,
            })}
          </Box>
        </Grid>
      )}
    </Grid>
  );

  const iraLayout = () => (
    <Grid
      container
      role="region"
      aria-labelledby="letsStartheading"
      aria-describedby="contactDisclaimerId"
    >
      <Grid container size={{ xs: 12 }}>
        {isIRAEducativa ? (
          <Typography sx={classes.educativaHeading}>
            {t('Select your contribution year', {
              defaultValue: 'Select your contribution year',
            })}
          </Typography>
        ) : (
          <Typography
            sx={classes.contact_heading}
            id="letsStartheading"
            variant="h2"
            aria-label={t(cdFlowOffers?.iraType, {
              defaultValue: cdFlowOffers?.iraType,
            })}
          >
            {t(cdFlowOffers?.iraType, {
              defaultValue: cdFlowOffers?.iraType,
            })}
          </Typography>
        )}
      </Grid>

      <Grid
        container
        sx={
          isIRAEducativa
            ? { marginTop: '24px' }
            : [classes.inputs_grid_margin, classes.margin_adjust_for_top_grid]
        }
        width="100%"
      >
        <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={classes.input_grid_padding}>
          <InputLabel
            htmlFor="contributionYear"
            required
            id="contributionYear_label"
            data-testid="contributionYear_testid"
            sx={{ marginBottom: '8px' }}
            aria-label={`${t('Contribution year*', {
              defaultValue: 'Contribution year*',
            })} ${t(REQUIRED, {
              defaultValue: REQUIRED,
            })}`}
          >
            {t(CONTRIBUTION_YEAR, {
              defaultValue: CONTRIBUTION_YEAR,
            })}
          </InputLabel>
          <Grid
            container
            spacing={2}
            sx={{
              flexWrap: 'wrap',
              marginBottom: flowTypeETB === 'EtbFlow' ? '0px' : '10px',
            }}
          >
            <CustomTextCard
              cardList={cardsList}
              handleCardClick={handleYearChange}
              errorMessage={productDataIRAErrors.yearStatus}
              productDataIRA={productDataIRA}
            />
          </Grid>
        </Grid>

        {isBtwAprilAndOct15 && productDataIRA?.yearStatus?.id === 'priorTaxYear' && (
          <>
            {taxProofUploadStatus !== DONE && taxProofUploadStatus !== FAILED && (
              <Grid size={{ xs: 12, md: 12 }} sx={{ margin: '20px 20px 20px 0' }}>
                <Grid container>
                  <Grid
                    size={{ sm: 12, md: 12, lg: 12 }}
                    sx={{
                      backgroundColor: '#FDF7EB',
                      padding: '15px',
                      border: `1px solid #EFAB39`,
                      borderRadius: '6px',
                    }}
                  >
                    <Box display="flex">
                      <Box>
                        <InfoFilledIcon color="#EFAB39" />
                      </Box>
                      <Box marginLeft="12px">
                        <Typography component="p" variant="subtitle1">
                          <Box component="span" fontWeight={700}>
                            {t('important_label', {
                              defaultValue: 'important_label',
                            })}
                          </Box>{' '}
                          {t(SUBMIT_TAX_EXTENSION_DOCUMENT, {
                            defaultValue: SUBMIT_TAX_EXTENSION_DOCUMENT,
                          })}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid
              size={{ xs: 12, md: 12 }}
              sx={{ margin: flowTypeETB === 'EtbFlow' ? '0px 20px 0px 0' : '0px 0px 10px 0' }}
            >
              <CommonDocumentUpload
                setUploadStatus={setTaxProofUploadStatus}
                uploadData={productDataIRA}
                setUploadData={setProductDataIRA}
                setUploadDataError={setProductDataIRAErrors}
                uploadError={productDataIRAErrors}
                uploadStatus={taxProofUploadStatus}
                uploadFileData={taxFileData}
                setUploadFileData={setTaxFileData}
                uploadDocHeading="Upload evidence of your extension request."
                pagePath={BENEFICIARY_INFO}
                pageProps={props}
                fileType="Tax extension document"
                toolTipData={TOOLTIP_TAX_EXTENSION_DOCUMENT}
                columnLayout={isTab}
              />

              <Box
                component="span"
                sx={classes.error_message}
                role="alert"
                data-testid="document-upload--error"
              >
                {t(productDataIRAErrors?.document, {
                  defaultValue: productDataIRAErrors?.document,
                })}
              </Box>
            </Grid>
          </>
        )}

        {productDataIRA?.yearStatus?.id && isIRAEducativa && flowTypeETB !== 'EtbFlow' && (
          <BeneficiaryInfo />
        )}

        {productDataIRA?.yearStatus ? (
          <Grid size={{ xs: 12 }}>
            {isIRAEducativa && flowTypeETB === 'EtbFlow' && etbBeneficiaryJSX()}
            {(!isIRAEducativa ||
              (beneficiaryData?.etbSelection === 'view' &&
                beneficiaryData?.beneficiaryListCustId)) && (
              <>
                {flowTypeETB === 'EtbFlow' && (
                  <Grid size={{ xs: 12, md: 12 }} sx={{ margin: '20px 20px 20px 0' }}>
                    {Number((productDataIRA?.depositAmount ?? '0').toString().replace(/,/g, '')) !==
                      Number(maxContribution) &&
                      Object.entries(productDataIRA?.yearStatus || {}).length > 0 && (
                        <CustomInfoBanner bannerData={bannerData} />
                      )}
                  </Grid>
                )}
                <Grid container display="flex" alignItems="start" spacing={2} width="100%">
                  {(!isIRAEducativa || (isIRAEducativa && flowTypeETB === 'EtbFlow')) && (
                    <Grid
                      size={{ xs: remainingContribution > 0 ? 6 : 12, md: 6, lg: 6 }}
                      sx={classes.input_grid_padding}
                    >
                      <CustomInput
                        isBundle={isBundle(productName)}
                        dataTestId="depositAmount_id"
                        id="depositAmount"
                        required={isIRAEducativa}
                        startAdornment={
                          <InputAdornment position="start">
                            <Typography
                              component="p"
                              color={theme?.palette?.primary?.main}
                              sx={
                                isIRAEducativa && {
                                  font: 'normal normal 400 16px/20px Arial',
                                }
                              }
                            >
                              $
                            </Typography>
                          </InputAdornment>
                        }
                        inputLabelAriaLabel={`${t(DEPOSIT_AMOUNT, {
                          defaultValue: DEPOSIT_AMOUNT,
                        })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                        autoFocus
                        handleChange={handleChange}
                        handleBlur={(e) => handleBlur(e)}
                        handleFocus={handleFocus}
                        label={
                          <span
                            style={{
                              color:
                                isBundle(productName) && productDataIRAErrors?.depositAmount
                                  ? 'red'
                                  : 'inherit',
                            }}
                          >
                            {t(isBundle(productName) ? 'DEPOSIT_AMOUNT_BUNDLE' : DEPOSIT_AMOUNT)}
                          </span>
                        }
                        inputLabelSX={{ overflow: 'visible', whiteSpace: 'nowrap' }}
                        inputProps={{
                          'data-testid': 'deposit-amount',
                          maxLength: 7,
                          inputMode: 'numeric',
                        }}
                        disabled={
                          !productDataIRA.yearStatus.id ||
                          productDataIRA?.knockOFf ||
                          amountCalcuationForYear === 0
                        }
                        placeholder={t(DEPOSIT_AMOUNT, {
                          defaultValue: DEPOSIT_AMOUNT,
                        })}
                        fullWidth
                        error={commonUtility(productDataIRAErrors?.depositAmount)}
                        value={productDataIRA?.depositAmount}
                      />
                      <Box
                        component="span"
                        sx={classes.error_message}
                        role="alert"
                        data-testid="deposit-amount-error"
                      >
                        {t(productDataIRAErrors?.depositAmount, {
                          defaultValue: productDataIRAErrors?.depositAmount,
                        })}
                      </Box>
                    </Grid>
                  )}
                  {flowTypeETB === 'EtbFlow' && (
                    <>
                      <Grid
                        size={{ xs: remainingContribution > 0 ? 6 : 12, md: 6, lg: 6 }}
                        sx={{ paddingTop: '28px' }}
                      >
                        {remainingContribution > 0 && (
                          <Button
                            sx={{
                              ...commonClasses.continue_button,
                              '&.Mui-disabled': commonClasses.save_disabled_button,
                              width: '100% !important',
                              maxWidth: '165px !important',
                            }}
                            onClick={handleMaxButton}
                            disabled={!productDataIRA.yearStatus.id || productDataIRA?.knockOFf}
                          >
                            {' '}
                            {t('Maximize', {
                              defaultValue: 'Maximize',
                            })}
                          </Button>
                        )}
                      </Grid>
                      <Grid
                        size={{ xs: 12, md: 6 }}
                        display="flex"
                        alignItems="flex-end"
                        sx={classes.input_grid_padding}
                      >
                        <CustomLinearProgres
                          progressVal={Number(
                            productDataIRA?.depositAmount?.toString().replace(/[^0-9.]/g, '')
                          )}
                          maxProgressVal={maxContribution}
                          triggerLinearprogress={productDataIRA.yearStatus?.id}
                        />
                      </Grid>
                    </>
                  )}
                  {(!!remainingContribution || !!maxContribution) && flowTypeETB === 'EtbFlow' && (
                    <Grid size={{ xs: 12, md: 12 }} sx={styles.infoContainer}>
                      <Box component="span">
                        <InfoFilledIcon color="#A7A7A7" />
                      </Box>
                      <Typography
                        id="letsStartheading"
                        variant="subtitle1"
                        sx={{ color: '#727578' }}
                        aria-label={t(LETS_START_SUB_HEAD, {
                          defaultValue: LETS_START_SUB_HEAD,
                        })}
                      >
                        {isIRAEducativa
                          ? t(
                              'The contribution limit per beneficiary and for the selected tax year is',
                              {
                                defaultValue:
                                  'The contribution limit per beneficiary and for the selected tax year is',
                              }
                            )
                          : t('Contribution limit selected tax year message', {
                              contributionLimit: (
                                contributionLimits[productDataIRA?.yearStatus?.id] || 0
                              ).toLocaleString(),
                            })}
                        {isIRAEducativa && (
                          <Typography component="span" sx={styles.amountText}>
                            &nbsp;$1000.
                          </Typography>
                        )}
                      </Typography>
                    </Grid>
                  )}
                  {!isIRAEducativa && flowTypeETB !== 'EtbFlow' && (
                    <Grid size={{ xs: 12, md: 12 }} sx={styles.infoContainer}>
                      <Box component="span">
                        <InfoFilledIcon color={isLimitExceeded ? 'red' : '#A7A7A7'} />
                      </Box>
                      <Typography
                        id="letsStartheading"
                        variant="subtitle1"
                        sx={{ color: isLimitExceeded ? 'red' : '#727578' }}
                        aria-label={t(LETS_START_SUB_HEAD, {
                          defaultValue: LETS_START_SUB_HEAD,
                        })}
                      >
                        {t('Contribution limit selected tax year message', {
                          contributionLimit: (
                            contributionLimits[productDataIRA?.yearStatus?.id] || 0
                          ).toLocaleString(),
                        })}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
                {beneficiaryData?.beneficiaryLists?.dobUploadFlag === 'true' && (
                  <Grid size={{ xs: 12 }}>
                    <CommonDocumentUpload
                      uploadData={birthProofUploadData}
                      setUploadData={setBirthProofUploadData}
                      uploadError={birthProofUploadError}
                      setUploadDataError={setBirthProofUploadError}
                      setUploadStatus={setBirthProofUploadStatus}
                      uploadStatus={birthProofUploadStatus}
                      uploadFileData={birthProofUploadData}
                      setUploadFileData={setBirthProofUploadData}
                      uploadDocHeading="Upload the beneficiary's birth certificate"
                      pagePath={BENEFICIARY_INFO}
                      pageProps={props}
                      fileType="Date of birth certificate"
                      toolTipData={isABC ? TOOLTIP_ABC_BIRTH_PROOF : TOOLTIP_EDUCATIVA_BIRTH_PROOF}
                      columnLayout={isTab}
                    />
                    <Box
                      component="span"
                      sx={classes.errorMessage}
                      role="alert"
                      data-testid="document-upload--error"
                    >
                      {t(birthProofUploadError?.document, {
                        defaultValue: birthProofUploadError?.document,
                      })}
                    </Box>
                  </Grid>
                )}
              </>
            )}
          </Grid>
        ) : null}
      </Grid>
    </Grid>
  );

  const abcLayout = () => (
    <Grid size={{ xs: 12 }} sx={styles.inputContainer}>
      {flowTypeETB === 'EtbFlow' && etbBeneficiaryJSX()}
      {beneficiaryData?.beneficiaryListCustId && <BeneficiaryCardComp />}
      {beneficiaryData?.etbSelection !== 'view' && <BeneficiaryInfo />}
    </Grid>
  );

  return (
    <>
      <Grid container sx={classes.contact_grid_margin}>
        <Grid container sx={classes.educativaContainer} spacing={0} data-page={BENEFICIARY_INFO}>
          {isABC ? abcLayout() : iraLayout()}
        </Grid>
        <CDIRAModals
          openCDIraModal={openCDIraModal}
          setOpenCDIraModal={setOpenCDIraModal}
          content={cdIraModalContent}
        />
      </Grid>
      {loader && (
        <div className="loader-style">
          <Loader />
        </div>
      )}
    </>
  );
};

export default BeneficiaryContent;

BeneficiaryContent.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
